import * as React from 'react'
import { TableOLD } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'
import { Dispatch, FC, SetStateAction } from 'react'
import { Need, Skill, SkillCategory, SkillNeedTemplate } from '@lmc/ts-common'
import { getCategories, getNeeds, getSkill, getValidity } from './utils'

type Props = {
  skillOptions: Skill[]
  needOptions: Need[]
  categoriesOptions: SkillCategory[]
  skillNeedTemplates: SkillNeedTemplate[]
  setTemplateDetail: Dispatch<SetStateAction<SkillNeedTemplate | undefined>>
  allowCreateEditTemplates?: boolean
}
export const SkillNeedTemplateTable: FC<Props> = ({
  skillNeedTemplates,
  skillOptions,
  needOptions,
  categoriesOptions,
  setTemplateDetail,
  allowCreateEditTemplates,
}) => {
  const { t } = useTranslation()

  return (
    <TableOLD
      columns={[
        { key: 'skills', title: t(`skillsAndNeeds.table.skills`) as string },
        {
          key: 'training',
          title: t(`skillsAndNeeds.table.training`) as string,
        },
        {
          key: 'validity',
          title: t(`skillsAndNeeds.table.validity`) as string,
        },
        {
          key: 'coveredNeeds',
          title: t(`skillsAndNeeds.table.coveredNeeds`) as string,
        },
        {
          key: 'category',
          title: t(`skillsAndNeeds.table.category`) as string,
        },
      ]}
      onRow={(record: Skill | unknown) => ({
        onClick: () =>
          allowCreateEditTemplates &&
          setTemplateDetail(
            skillNeedTemplates.find(
              (skill) => skill.id === (record as Skill).id
            )
          ),
      })}
      rows={skillNeedTemplates.map((skill) => {
        const doesNotExpire =
          skill?.trainingValidFor === 0 || !skill.trainingValidFor

        return {
          key: skill?.id,
          id: skill?.id,
          skills: getSkill(skill.skill as string, skillOptions),
          training: skill?.trainingName || '-',
          validity:
            doesNotExpire && skill?.trainingRequired
              ? '∞'
              : getValidity(t, skill.trainingValidFor) || '-',
          coveredNeeds: getNeeds((skill?.needs as string[]) || [], needOptions),
          category: getCategories(
            (skill?.categories as string[]) || [],
            categoriesOptions
          ),
          mandatory: skill.mandatory
            ? t(`skillsAndNeeds.table.yes`)
            : t(`skillsAndNeeds.table.no`),
        }
      })}
    />
  )
}

export default SkillNeedTemplateTable
